export enum NewNearMissLoadingState {
    loadingNearMiss = 'ObservationPage.LoadingPage',
    submitting = 'ObservationPage.SubmittingNearMiss',
    uploadingFiles = 'ObservationPage.UploadingFiles'
}